var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "category-footer" }, [
    _c(
      "div",
      { staticClass: "footer-container" },
      [
        _c("router-link", { attrs: { to: "/about" } }, [_vm._v("About Us")]),
        _vm._v(" "),
        _c("router-link", { attrs: { to: "/guidelines" } }, [
          _vm._v("Guidelines"),
        ]),
        _vm._v(" "),
        _c("a", { attrs: { href: "https://lmk.zendesk.com/hc/en-us" } }, [
          _vm._v("FAQ"),
        ]),
        _vm._v(" "),
        _c("a", { attrs: { href: "mailto:support@lmk.chat" } }, [
          _vm._v("Careers"),
        ]),
        _vm._v(" "),
        _c("router-link", { attrs: { to: "/tos" } }, [_vm._v("Terms")]),
        _vm._v(" "),
        _c("router-link", { attrs: { to: "/privacy" } }, [_vm._v("Privacy")]),
        _vm._v(" "),
        _c(
          "a",
          {
            attrs: {
              href: "https://lmk.zendesk.com/hc/en-us/sections/360008425653-Safety-Center",
            },
          },
          [_vm._v("Safety")]
        ),
        _vm._v(" "),
        _c(
          "a",
          { attrs: { href: "https://lmk.zendesk.com/hc/en-us/requests/new" } },
          [_vm._v("Contact Us")]
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c("p", { staticClass: "copy_right_txt" }, [_vm._v("© 2021 LMK")]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// src/components/common/CategoryFooter.vue